import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function NotFound() {
    return (
        <div data-testid="not-found-page">
            <Helmet>
                <title>Page not found | GrowVise</title>
                <meta name="robots" content="noindex" />
            </Helmet>
            <section className="bg-navy-950 pt-40 pb-28 min-h-[70vh]">
                <div className="max-w-6xl mx-auto px-5 sm:px-8">
                    <p className="eyebrow">404</p>
                    <h1 className="mt-6 font-serif font-semibold text-white tracking-tight leading-[1.15] text-4xl sm:text-5xl max-w-2xl">
                        That page doesn't exist.
                    </h1>
                    <p className="mt-6 text-base sm:text-lg text-slate-300/90 leading-relaxed max-w-xl">
                        It may have moved when the site was updated. Try one of these instead.
                    </p>
                    <div className="mt-9 flex flex-wrap gap-4">
                        <Link to="/" className="btn-gold">Go to the homepage</Link>
                        <Link to="/how-we-help" className="btn-outline">How we help</Link>
                        <Link to="/book-a-conversation" className="btn-outline">Book a conversation</Link>
                    </div>
                </div>
            </section>
        </div>
    );
}
